import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LOG_CONTEXT } from '@rms/core/http';
import { environment } from '@rms/env';
import { Observable } from 'rxjs';

import { PasswordChangeRequest, UserProfile, UserProfileUpdateRequest } from '../models';

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiEndpoint}/v1/users`;
  private readonly meUrl = `${environment.apiEndpoint}/v1/partners/users/me`;

  public getUser(userId: string): Observable<UserProfile> {
    return this.http.get<UserProfile>(`${this.baseUrl}/${userId}`, {
      context: new HttpContext().set(LOG_CONTEXT, 'UserApiService.getUser'),
    });
  }

  public updateUser(userId: string, request: UserProfileUpdateRequest): Observable<UserProfile> {
    return this.http.put<UserProfile>(`${this.baseUrl}/${userId}`, request, {
      context: new HttpContext().set(LOG_CONTEXT, 'UserApiService.updateUser'),
    });
  }

  public changePassword(request: PasswordChangeRequest): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/credentials`, request, {
      context: new HttpContext().set(LOG_CONTEXT, 'UserApiService.changePassword'),
    });
  }

  public getMe(): Observable<UserProfile> {
    return this.http.get<UserProfile>(this.meUrl, {
      context: new HttpContext().set(LOG_CONTEXT, 'UserApiService.getMe'),
    });
  }

  public updateMe(request: UserProfileUpdateRequest): Observable<UserProfile> {
    return this.http.put<UserProfile>(this.meUrl, request, {
      context: new HttpContext().set(LOG_CONTEXT, 'UserApiService.updateMe'),
    });
  }

  public changeMyPassword(request: PasswordChangeRequest): Observable<void> {
    return this.http.put<void>(`${this.meUrl}/credentials`, request, {
      context: new HttpContext().set(LOG_CONTEXT, 'UserApiService.changeMyPassword'),
    });
  }
}
